<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

const { isOpen, title, description, cancelText, actionText, variant, width, confirm, cancel } = useAlertDialog()
</script>

<template>
  {{ width }}
  <AlertDialog :open="isOpen" @update:open="(val) => !val && cancel()">
    <AlertDialogContent class="z-[9999]" :class="width">
      <AlertDialogHeader>
        <AlertDialogTitle v-if="title">
          {{ title }}
        </AlertDialogTitle>
        <AlertDialogDescription v-if="description">
          {{ description }}
        </AlertDialogDescription>
      </AlertDialogHeader>

      <AlertDialogFooter>
        <AlertDialogCancel @click="cancel">
          {{ cancelText }}
        </AlertDialogCancel>
        <AlertDialogAction
          :class="{
            'bg-destructive text-destructive-foreground hover:bg-destructive/90': variant === 'destructive',
          }"
          @click="confirm"
        >
          {{ actionText }}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
